import { editClinicianUsernameMapping, editProviderTeamMapping } from '../../../actions/areas/admin/commandActions';
import globals from '../../../globals/communityGlobals';

const locale = globals.getAreas(['activityTypes', 'error', 'userActions', 'externalProvider']);
const defaultValues = { id: null, orgUnitId: null };

export const eventHandlers = (state, setState, auth) => {
  const handleSidePanel = (isOpen, data) => {
    // eslint-disable-next-line no-unused-expressions
    data != null
      ? setState(newState => ({
          ...newState,
          openSidePanel: isOpen,
          selectedRow: data,
        }))
      : setState(newState => ({ ...newState, openSidePanel: isOpen, selectedRow: defaultValues }));
  };
  const refreshTable = () =>
    setState(newState => ({
      ...newState,
      forceReload: !state.forceReload,
      isDataLoading: false,
      openSidePanel: false,
      errorMsg: null,
    }));
  const updateTableProps = (currentPage, pageSize) => setState({ ...state, currentPage, pageSize });
  const updateTableSort = (sortColumn, sortDirection) => setState({ ...state, sortColumn, sortDirection });
  const errorCallback = response => {
    setState(newState => ({ ...newState, errorMsg: response }));
    handleSidePanel(true);
  };

  const onClose = () => {
    setState(newState => ({ ...newState, openSidePanel: false, errorMsg: null }));
  };

  return {
    locale,
    refreshTable,
    handleSidePanel,
    updateTableProps,
    updateTableSort,
    onClose,
    editClinicianMappingModel: model => {
      editClinicianUsernameMapping(auth, model, refreshTable, errorCallback);
    },
    editProviderTeamMappingModel: model => {
      editProviderTeamMapping(auth, model, refreshTable, errorCallback);
    },
  };
};
